// extracted by mini-css-extract-plugin
export var container = "_5w-0";
export var icon = "_5w-1";
export var text = "_5w-2";